import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavPurchasesIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M9.25 12.25V10.75H7.75006C7.33585 10.75 7.00006 10.4142 7.00006 10C7.00006 9.58579 7.33585 9.25 7.75006 9.25H9.25V7.75C9.25 7.33579 9.58579 7 10 7C10.4142 7 10.75 7.33579 10.75 7.75V9.25H12.25C12.6642 9.25 13 9.58579 13 10C13 10.4142 12.6642 10.75 12.25 10.75H10.75V12.25C10.75 12.6642 10.4142 13 10 13C9.58579 13 9.25 12.6642 9.25 12.25Z"
          fill="inherit"
        />
        <path
          d="M14.0713 18C15.1364 18 16 17.1046 16 16V4C16 2.89543 15.1364 2 14.0713 2H11.7139C11.7139 2.98184 10.9468 3.77734 10 3.77734L9.8252 3.76855C9.01814 3.68379 8.37684 3.01854 8.29492 2.18164L8.28613 2H5.92871L5.73145 2.01074C4.75894 2.11315 4 2.96446 4 4V16C4 17.0355 4.75895 17.8868 5.73145 17.9893L5.92871 18H8.28613C8.28613 17.0182 9.05323 16.2227 10 16.2227L10.1748 16.2314C11.0395 16.3223 11.7139 17.0794 11.7139 18H14.0713ZM5.92871 16.5C5.74297 16.5 5.5 16.328 5.5 16V4C5.5 3.67197 5.74297 3.5 5.92871 3.5H7.14551C7.67173 4.54059 8.72881 5.27734 10 5.27734C11.2712 5.27734 12.3283 4.54059 12.8545 3.5H14.0713C14.257 3.5 14.5 3.67197 14.5 4V16C14.5 16.328 14.257 16.5 14.0713 16.5H12.8545C12.3283 15.4594 11.2712 14.7227 10 14.7227C8.72881 14.7227 7.67173 15.4594 7.14551 16.5H5.92871Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
